<label *ngIf="!config['isHidden']" class="label input-text">
  {{ config.label | translate }}
</label>
